import React, { PureComponent } from 'react';
import styled from 'styled-components';
import Grid from '@material-ui/core/Grid';
import Sticky from 'react-stickynode';
import ConnectedBookModule from './Book/components/BookModule/ConnectedBookModule';
import { propTypes } from './../../shapes/ClinicDetailPage';
import { isBookable, isTraditionalLocation } from '../../core/util/location';
import Sections from './Sections';
import NearbyClinics from './Book/components/NearbyClinics';
import Accreditation from './Book/components/Accreditation';
import SchemaOrgMainAttributes from './MetaTags/SchemaOrgMainAttributes';
import NearbyTelemed from './Book/components/NearbyTelemed';
import DesktopCdpHeaderCard from './HeaderCard/DesktopCdpHeaderCard';

const StickyBottomAnchor = styled.div`
  margin-bottom: 20px;
`;

const StyledDivider = styled.div`
  margin-top: 40px;
`;

const RightRail = styled(Grid)`
  padding-left: 35px;
`;

export default class Desktop extends PureComponent {
  static propTypes = propTypes;

  render = () => {
    const {
      location,
      newBooking,
      handleOpenCarousel,
      viewport,
      nearbyLocations,
      showModal,
      className,
      handleRequestAppointmentClick,
      setBookingProfile,
      fetchLocationSlotsData,
      accountSummary,
      login,
      suggestions,
      reasonForVisit,
      sessionTrackingProperties,
    } = this.props;

    return (
      <Grid container className={className} itemScope itemType="http://schema.org/MedicalClinic">
        <SchemaOrgMainAttributes location={location} />
        <Grid item lg={8} sm={7}>
          <DesktopCdpHeaderCard
            handleOpenCarousel={handleOpenCarousel}
            location={location}
            showModal={showModal}
            viewport={viewport}
            sessionTrackingProperties={sessionTrackingProperties}
          />
          <StyledDivider />
          <Sections
            location={location}
            enableCollapsing={null}
            handleOpenCarousel={() => handleOpenCarousel('photosSection')}
            nearbyLocations={nearbyLocations}
            viewport={viewport}
            showModal={showModal}
            sessionTrackingProperties={sessionTrackingProperties}
          />
        </Grid>
        <RightRail item lg={4} md={5}>
          <Sticky enabled top={10} bottomBoundary={'#bottom-anchor'}>
            {isBookable(location) && (
              <ConnectedBookModule
                login={login}
                newBooking={newBooking}
                accountSummary={accountSummary}
                fetchLocationSlotsData={fetchLocationSlotsData}
                location={location}
                showModal={showModal}
                handleRequestAppointmentClick={handleRequestAppointmentClick}
                suggestions={suggestions}
                reasonForVisit={reasonForVisit}
                setBookingProfile={setBookingProfile}
              />
            )}
            {!isBookable(location) && !isTraditionalLocation(location) && (
              <NearbyClinics nearbyClinics={nearbyLocations.nearby} currentLocation={location} />
            )}
            <NearbyTelemed location={nearbyLocations.telemed} referrerId={location.id} />
            <Accreditation location={location} />
          </Sticky>
        </RightRail>
        <StickyBottomAnchor id="bottom-anchor" />
      </Grid>
    );
  };
}
